<template>
  <div style="width: 100%;height: 100%;" class="overflow-auto px-8px pt-8px pb-8px" v-show="elementListShow == false">
    <div class="search flex items-center gap-[4px]">
      <el-input v-model="searchValue" placeholder="请输入搜索内容" clearable :prefix-icon="Search"></el-input>
      <el-button type="primary" @click="handleSearch" style="background-color: #2a66ff;">搜索</el-button>
    </div>
    <div class="menu-list grid grid-cols-4 gap-[4px]">
      <div v-for="item in menuList" :key="item.id" @click="handleCategoryClick(item)" class="menu-item"
        :style="{ 'backgroundImage': `url(${item.cover_image})` }">
      </div>
    </div>
    <div class="recommend-list">
      <div v-for="item in recommendList" :key="item.id">
        <div class="title flex items-center justify-between mt-[32px] mb-[16px]" v-if="item.materials.list.length > 0">
          <div class="text-ellipsis whitespace-nowrap overflow-hidden font-bold">{{ item.name }}</div>
          <div class="more cursor-pointer" @click="handleMoreClick(item)"> 更多</div>
        </div>
        <div class="imageList ">
          <div v-for="(img, index) in getimage(item.materials.list)" :key="index"
            class="w-[33%] h-[80px] rounded-md overflow-hidden">
            <elementItem :template="img"> </elementItem>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="element-list" v-if="elementListShow">
    <elementlist :categoriesElementList="categoriesElementList" :categoriesShow="categoriesShow"
      :searchShow="searchShow" @back="elementListShow = false" :list="List"></elementlist>
  </div>
</template>

<script lang="ts" setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { ElInput, ElButton, ElCascader } from 'element-plus'
import { ArrowDown, Search } from '@element-plus/icons-vue'
import { getCategories, recommendations, gettagMaterials } from '@/api/affairs'
// @ts-ignore
import elementItem from './elmentItem.vue'
// @ts-ignore
import elementlist from './elementlist.vue'
const menuList = ref([])
const recommendList = ref([])
const props = defineProps<{
  type?: string
}>()
const searchValue = ref('')
const handleSearch = () => {

}
const elementListShow = ref(false)
const categoriesElementList = ref([])
const searchShow = ref(true)
const categoriesShow = ref(true)
const List = ref([])


onMounted(() => {
  getCategories({ category_type: 3, size: 20, type: props.type == 'team' ? 2 : 1 }).then(res => {
    menuList.value = res.data.data
  })
  getList()
})
const handleCategoryClick = (item) => {
  categoriesElementList.value = item
  searchShow.value = true
  categoriesShow.value = true
  elementListShow.value = true
  console.log(item)
}
const getList = () => {
  gettagMaterials({ key: 'scene', hot_type: 3, page: 1, size: 100, }).then((res) => {
    const data = res.data.data.categories[0].children
    console.log('data---', data
    )
    recommendList.value = data
  })
}
const handleMoreClick = (item) => {
  searchShow.value = false
  categoriesShow.value = false
  elementListShow.value = true
  // console.log(item)
  List.value = item
}
const getimage = (val) => {
  return val.slice(0, 3)
}
</script>
<style lang="scss">
.menu-item {
  border-radius: 6px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 12px;
  background-color: #fff;
  margin-top: 16px;
  background-size: 100% 100%;
  height: 46px;

}

.imageList {
  display: flex;
  gap: 4px;
  width: 100%;

}
</style>
